import { render, staticRenderFns } from "./wf-date-selector-edit.vue?vue&type=template&id=50de2f4c&scoped=true&"
import script from "./wf-date-selector-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-date-selector-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-date-selector-edit.vue?vue&type=style&index=0&id=50de2f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de2f4c",
  null
  
)

export default component.exports